import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { tap, map } from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import { ApiConfig } from '../config/apiConfig';
@Injectable({
  providedIn: 'root'
})
export class EquipmentService {
  GetFacilityMasterdata = new Subject<any>();
  private rootUrl: string;
  private equipmentAPIUrl;
  
  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.equipmentAPIUrl = ApiConfig.EquipmentApiConfig;
  }
  
  getFacilityEquipmentManager(equipObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getFacilityEquipmentManager}`, equipObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getFacilityEquipmentList(equipObj:any):Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getFacilityEquipmentList}`, equipObj )
    .pipe(
      tap(() => {
      })
    );
}

  getEquipmentTypes(): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentTypes}`, '')
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getEquipmentSubtypes(equipObj:any):Observable<any> {
    return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentSubTypes}`,  equipObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getRepairResults(equipObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getRepairResults}`,equipObj  
  )
    .pipe(
      tap(() => {
        //
      })
    );
}

getEquipmentHistoryResults(equipObj: any): Observable<any> {
      return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentHistoryResults}`, equipObj)
      .pipe(
        tap(() => {
        })
      );
  }
  
getEquipmentScheduleHistory(equipObj: any): Observable<any> {
      return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentScheduleHistory}`,equipObj
        
    )
      .pipe(
        tap(() => {
        })
      );
}
getEquipmentMpi(equipObj: any): Observable<any> {
      return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentMpi}`,equipObj
        
    )
      .pipe(
        tap(() => {
        })
      );
}


getFaceilityManger(equipObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getFacilityEquipmentManager}`,equipObj
      
      
    )
      .pipe(
        tap(() => {
        })
      );
}

updateEuipment(equipObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.updateEquipment}`,equipObj )
      .pipe(
        tap(() => {
        })
      );
}

getEquipmentStatus(): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentStatus}`, JSON.stringify({})
 )
}


getEquipmentModality(): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentModality}`, JSON.stringify({})
 )
}
getEquipmentConditions(): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentConditions}`, JSON.stringify({})
 )
}
getEquipmentOrigins(): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentOrigins}`, JSON.stringify({})
 )
}

inserUpdateMPI(equipObj: any):Promise<any>{
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.insertUpdateEquipmentMpi}`,equipObj
    
  ).toPromise()
}

addEquipmentSchedule(equipObj: any): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.addEquipmentSchedule}`,equipObj
    
  )
    .pipe(
      tap(() => {
      })
    );
}

validateSerial(equipObj: any): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.validateSerial}`,equipObj
    
  )
    .pipe(
      tap(() => {
      })
    );
}

getFacilityEquipment(equipObj: any): Observable<any>  {
  return this.http.post(`${ConfService.conf.environment.apiRootUrl}${this.equipmentAPIUrl.getFacilityEquipment}`, equipObj  )
  .pipe(
    tap(() => {
    })
  );
}
getFacilityEquipmentMassTransfer(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getFacilityEquipmentMassTransfer}`,equipObj)     
  .pipe(
    tap(() => {
    })
  );
}

transferEquipment(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.transferEquipment}`,equipObj)     
  .pipe(
    tap(() => {
    })
  );
}
updateEquipmentStatus(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.updateEquipmentStatus}`,equipObj)     
  .pipe(
    tap(() => {
    })
  );
}
getEquipmentLocationId(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentLocationId}`,equipObj)     
  .pipe(
    tap(() => {
    })
  );
}
//Start:Added By Harikesh on 08-June-2020
getMachineNickName(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getMachineNickName}`,equipObj)     
  .pipe(
    tap(() => {
    })
  );
}
getMachineIPAddress(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getMachineIPAddress}`,equipObj)     
  .pipe(
    tap(() => {
      //
    })
  );
}
getEquipmentAlerts(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentAlerts}`,equipObj)     
  .pipe(
    tap(() => {
      //
    })
  );
}
validateIproc(equipObj: any): Observable<any> {    
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.validateIproc}`,equipObj)     
  .pipe(
    tap(() => {
      //
    })
  );
}

//End:Added By Harikesh on 08-June-2020

addEquipment(equipObj:any):Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.addEquipment}`, equipObj
  
   )
    .pipe(
      tap(() => {
        //
      })
    );
}

validateSerialSync(equipObj:any): Promise<any> {
 
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.validateSerial}`, equipObj
  
  ).toPromise()
}
validateMachineNickNameSync(equipObj:any): Promise<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.validateMachineNickName}`, equipObj
 
  ).toPromise()
}

UpdateNickName(equipObj: any): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.UpdateNickName}`,equipObj)
    .pipe(
      tap(() => {
        //
      })
    );
}

validateMachineNickName(equipObj: any): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.validateMachineNickName}`,equipObj)
    .pipe(
      tap(() => {
        //
      })
    );
}

validateMachineIPAddress(equipObj: any): Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.validateMachineIPAddress}`,equipObj)
    .pipe(
      tap(() => {
        //
      })
    );
}
 
getEquipmentTickets(equipObj:any):Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getEquipmentTickets}`, equipObj)
    .pipe(
      tap(() => {
        //
      })
    );
}

validateMachineIPAddressSync(equipObj:any): Promise<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.validateMachineIPAddress}`, equipObj
 
  ).toPromise()
}
 
mergeEquipment(equipObj:any):Observable<any> {
  return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.mergeEquipment}`, equipObj)
    .pipe(
      tap(() => {
        //
      })
    );
}

  getPMTypes(pMTypesObj): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.equipmentAPIUrl.getPMTypes}`, pMTypesObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }
}